import React from 'react';
import { motion } from 'framer-motion';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';
interface AnimatedSectionProps {
  children: React.ReactNode;
  className?: string;
}
export function AnimatedSection({
  children,
  className = ''
}: AnimatedSectionProps) {
  const {
    ref,
    isIntersecting
  } = useIntersectionObserver();
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 30
  }} animate={isIntersecting ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.6
  }} className={className} data-id="element-188">
      {children}
    </motion.div>;
}